import { render, staticRenderFns } from "./popCompositionAdd.vue?vue&type=template&id=841dc0b6&"
import script from "./popCompositionAdd.vue?vue&type=script&lang=js&"
export * from "./popCompositionAdd.vue?vue&type=script&lang=js&"
import style0 from "./popCompositionAdd.vue?vue&type=style&index=0&id=841dc0b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports